import React from 'react'
import IconBase from './IconBase'

const Back = props =>
  <IconBase viewBox="0 0 23.8 41.1" {...props}>
    <path d="m1.3 18.5l17.3-17.2c1.1-1.1 2.9-1.1 4 0s1.1 2.9 0 4l-15.3 15.2 15.2 15.2c1.1 1.1 1.1 2.9 0 4s-2.9 1.1-4 0l-17.2-17.2c-1.1-1.1-1.1-2.9 0-4z"/>
  </IconBase>

export default Back
